import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var genVirtualStyle = function genVirtualStyle(token) {
  var _$concat2, _$concat6, _$concat7;
  var componentCls = token.componentCls,
    motionDurationMid = token.motionDurationMid;
  var tableBorder = "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.tableBorderColor);
  var rowCellCls = "".concat(componentCls, "-expanded-row-cell");
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), (_$concat7 = {}, _defineProperty(_$concat7, "".concat(componentCls, "-tbody-virtual"), (_$concat2 = {}, _defineProperty(_$concat2, "".concat(componentCls, "-row"), {
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%'
  }), _defineProperty(_$concat2, "".concat(componentCls, "-cell"), {
    borderBottom: tableBorder,
    transition: "background ".concat(motionDurationMid)
  }), _defineProperty(_$concat2, "".concat(componentCls, "-expanded-row"), _defineProperty({}, "".concat(rowCellCls).concat(rowCellCls, "-fixed"), {
    position: 'sticky',
    insetInlineStart: 0,
    overflow: 'hidden',
    width: "calc(var(--virtual-width) - ".concat(token.lineWidth, "px)"),
    borderInlineEnd: 'none'
  })), _$concat2)), _defineProperty(_$concat7, "".concat(componentCls, "-bordered"), (_$concat6 = {}, _defineProperty(_$concat6, "".concat(componentCls, "-tbody-virtual"), _defineProperty({
    '&:after': {
      content: '""',
      insetInline: 0,
      bottom: 0,
      borderBottom: tableBorder,
      position: 'absolute'
    }
  }, "".concat(componentCls, "-cell"), _defineProperty({
    borderInlineEnd: tableBorder
  }, "&".concat(componentCls, "-cell-fix-right-first:before"), {
    content: '""',
    position: 'absolute',
    insetBlock: 0,
    insetInlineStart: -token.lineWidth,
    borderInlineStart: tableBorder
  }))), _defineProperty(_$concat6, "&".concat(componentCls, "-virtual"), _defineProperty({}, "".concat(componentCls, "-placeholder ").concat(componentCls, "-cell"), {
    borderInlineEnd: tableBorder,
    borderBottom: tableBorder
  })), _$concat6)), _$concat7));
};
export default genVirtualStyle;